module.exports = __webpack_public_path__ + "img/result-icon.bf91ec9d.png";